import { PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';

// Configuração MSAL para Microsoft Entra ID
const msalConfig = {
  auth: {
    clientId:
      process.env.VUE_APP_AZURE_CLIENT_ID ||
      '90471a46-e413-430c-b617-3da3da250d7d',
    authority: `https://login.microsoftonline.com/${
      process.env.VUE_APP_AZURE_TENANT_ID ||
      '782eec7a-4964-417e-a8a5-5640efc757b8'
    }`,
    redirectUri: '/redirect',
    postLogoutRedirectUri: '/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  },
};

// Scopes necessários para acessar a API
const loginRequest = {
  scopes: [process.env.VUE_APP_AZURE_SCOPE || 'api://90471a46-e413-430c-b617-3da3da250d7d/API.Access'],
  // scopes: ['User.Read'],
  prompt: 'select_account',
};

// Configuração para logout
const logoutRequest = {
  postLogoutRedirectUri: '/login',
};

// Criar instância MSAL
const msalInstance = new PublicClientApplication(msalConfig);

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

export { msalInstance, loginRequest, logoutRequest };
export default msalInstance;
